import Component from './trainingV2.component';
import { Config } from './trainingV2.config';

export default { Component, config: Config };
